module.exports = __webpack_public_path__ + "assets/img/box1_img.3c3b3b95.png";